import { styled } from "@pigment-css/react";
import { Checkbox } from "radix-ui";
import { CheckMark2Small } from "@acto/web-common/components";
import { RowBody, RowMeta, RowTitle } from "@acto/taskpane/field-sales-2/components/primitives/Card";
import { MeetingPrepRowItem } from "@acto/taskpane/field-sales-2/components/patterns/genui-meeting-prep/rowPrimitives";
import { CheckboxSquare } from "@acto/taskpane/field-sales-2/components/primitives/SheetOptions";

const Row = styled("li")({ display: "flex" });

const RowControl = styled(MeetingPrepRowItem)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  alignItems: "flex-start",
  border: "none",
  background: "transparent",
  textAlign: "left",
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  outline: "none",
  "&:focus-visible [data-checkbox-square]": {
    outline: `${theme.strokeWidth.regular} solid ${theme.fieldSalesTwo.colors.neutral[700]}`,
    outlineOffset: theme.fieldSalesTwo.spacing[2],
  },
  "&:disabled": { opacity: 0.4, pointerEvents: "none" },
}));

const Potential = styled(RowMeta)(({ theme }) => ({
  color: theme.fieldSalesTwo.colors.status.success.main,
}));

interface SelectableProductRowProps {
  name: string;
  valueLabel?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function SelectableProductRow({
  name,
  valueLabel,
  checked,
  onCheckedChange,
  disabled,
}: SelectableProductRowProps) {
  return (
    <Row>
      <RowControl
        as={Checkbox.Root}
        clickable
        checked={checked}
        onCheckedChange={(next: boolean | "indeterminate") => onCheckedChange(next === true)}
        disabled={disabled}
      >
        <RowBody>
          <RowTitle>{name}</RowTitle>
          {valueLabel && <Potential>{valueLabel}</Potential>}
        </RowBody>
        <CheckboxSquare aria-hidden="true" data-checkbox-square>
          <CheckMark2Small />
        </CheckboxSquare>
      </RowControl>
    </Row>
  );
}
